import { render, staticRenderFns } from "./SortGridIcon.vue?vue&type=template&id=47412bb4&"
import script from "./SortGridIcon.vue?vue&type=script&lang=js&"
export * from "./SortGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports